import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { isValidSession, logout } from "../../utils/sessionStorage";
import { getParams } from "../../utils/common";

import { UserContext } from "../../context";

const UserAdmin = () => {
  const { actions } = useContext(UserContext);

  const token = getParams().token;
  const nav = useNavigate();
  const [permiso, setPermiso] = useState();
  // let permiso = false;
  // console.log(actions.hasRole('admin'))

  useEffect(() => {
    if (!isValidSession() && !token) nav("/login");
    if (!actions.hasRole("admin.app") && !actions.hasRole('admin')) {
      setPermiso(false);
      nav("/");
      return;
    }
    return setPermiso(true);
  }, []);

  // console.log(permiso)

  if (!isValidSession()) return null;

  return <>{permiso && <Outlet />}</>;
};

export default UserAdmin;
